import React from 'react'
import { RouteProps, Route, Redirect } from 'react-router-dom'
import { Validation, hasPermission } from '../utils'
import routes from '.'
export interface Props extends RouteProps {
  permission?: string
}
const PrivateRoute: React.FC<Props> = (props) => {
  const { children, permission, ...rest } = props

  const { isValidUserToken } = new Validation()

  function isAuthorizedUser(): boolean {
    const { token } = JSON.parse(localStorage.getItem('user') || '{}')
    return token === undefined ? false : isValidUserToken(token)
  }

  return (
    <Route
      {...rest}
      render={({ location }): any =>
        isAuthorizedUser() ? (
          permission == undefined || hasPermission(permission) ? (
            children
          ) : (
            <Redirect to={{ pathname: routes.error401 }} />
          )
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        )
      }
    />
  )
}

export default PrivateRoute
